// extracted by mini-css-extract-plugin
module.exports = {"modalUser":"style_modalUser__1Nj6E"};